import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { useCart, useGTM } from 'lib/core/hooks'
import { CheckoutDescription, CheckoutStep } from 'lib/core/services/gtm'
import {
  useCheckout,
  Styled,
  Nav,
  Totals,
  EmailForm,
  PlaceOrder,
  ShippingStep
} from 'lib/modules/checkout'

export const ShippingScene = () => {
  const { requiresShipping } = useCheckout()
  const { cart } = useCart()
  const { triggerCheckout } = useGTM()

  useEffect(() => {
    triggerCheckout({ cart, step: CheckoutStep.Shipping, description: CheckoutDescription.Shipping })
  }, [triggerCheckout, cart])

  if (!requiresShipping()) {
    return (
      <Redirect to='/checkout/billing' />
    )
  }

  return (
    <>
      <Nav />
      <Styled.Container>
        <h1>
          Shipping Information
        </h1>
        <Styled.CheckoutLayout>
          <Styled.CheckoutMain>
            <EmailForm />
            <Styled.MainFormContainer>
              <ShippingStep />
            </Styled.MainFormContainer>
          </Styled.CheckoutMain>
          <Styled.CheckoutAside>
            <div>
              <Totals />
              <PlaceOrder />
            </div>
          </Styled.CheckoutAside>
        </Styled.CheckoutLayout>
      </Styled.Container>
    </>
  )
}
